import { render, staticRenderFns } from "./wellcome.vue?vue&type=template&id=9c7f0994&scoped=true"
import script from "./wellcome.vue?vue&type=script&lang=js"
export * from "./wellcome.vue?vue&type=script&lang=js"
import style0 from "./wellcome.vue?vue&type=style&index=0&id=9c7f0994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7f0994",
  null
  
)

export default component.exports